<script>
  import { _ } from "svelte-i18n";

  export let session = { main: [], warmUp: [], conclusion: [] };

  // Check which endurance zones are used in this session
  $: allParts = []
    .concat(session.warmUp || [])
    .concat(session.main || [])
    .concat(session.conclusion || []);

  $: usedZones = {
    calm: allParts.some(
      (part) =>
        part.type === "endurance" &&
        part.metrics?.calm &&
        parseInt(part.metrics.calm) > 0
    ),
    moderate: allParts.some(
      (part) =>
        part.type === "endurance" &&
        part.metrics?.moderate &&
        parseInt(part.metrics.moderate) > 0
    ),
    high: allParts.some(
      (part) =>
        part.type === "endurance" &&
        part.metrics?.high &&
        parseInt(part.metrics.high) > 0
    ),
  };

  // Calculate total minutes per zone across all endurance elements
  $: totalZoneMinutes = {
    calm: allParts
      .filter((part) => part.type === "endurance")
      .reduce((sum, part) => sum + (parseInt(part.metrics?.calm) || 0), 0),
    moderate: allParts
      .filter((part) => part.type === "endurance")
      .reduce((sum, part) => sum + (parseInt(part.metrics?.moderate) || 0), 0),
    high: allParts
      .filter((part) => part.type === "endurance")
      .reduce((sum, part) => sum + (parseInt(part.metrics?.high) || 0), 0),
  };
</script>

{#if usedZones.calm || usedZones.moderate || usedZones.high}
  <div
    style="margin-left: 18px; margin-right: 36px; margin-bottom: 16px; margin-top: 40px;"
  >
    <div style="display: flex; gap: 16px; align-items: center;">
      {#if usedZones.calm}
        <div
          style="background-color: #6cea9f; border-radius: 2px; padding: 4px 8px; display: flex; align-items: center; justify-content: center;"
        >
                        <span style="font-size: 12px; color: black; font-weight: 500;"
                >{$_("sessions.form.endurance.calm")}: {totalZoneMinutes.calm} {$_("sessions.unit")}</span
              >
        </div>
      {/if}
      {#if usedZones.moderate}
        <div
          style="background-color: #fff871; border-radius: 2px; padding: 4px 8px; display: flex; align-items: center; justify-content: center;"
        >
                        <span style="font-size: 12px; color: black; font-weight: 500;"
                >{$_("sessions.form.endurance.moderate")}: {totalZoneMinutes.moderate}
                {$_("sessions.unit")}</span
              >
        </div>
      {/if}
      {#if usedZones.high}
        <div
          style="background-color: #ff8383; border-radius: 2px; padding: 4px 8px; display: flex; align-items: center; justify-content: center;"
        >
                        <span style="font-size: 12px; color: black; font-weight: 500;"
                >{$_("sessions.form.endurance.high")}: {totalZoneMinutes.high} {$_("sessions.unit")}</span
              >
        </div>
      {/if}
    </div>
  </div>
{/if}
